import { theme } from '@/styles/theme';

export const styles = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    overflowX: 'auto',
    paddingTop: 2,
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 26,
    },
  },
  listText: {
    paddingLeft: '12px',
  },
  description: {
    paddingTop: 0.5,
    color: theme.palette.gray.main,
    fontSize: '12px',
  },
  paymentCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: '300px',
  },
  totalValueBox: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 4,
  },
  totalValueText: {
    flexGrow: 1,
    color: theme.palette.gray.main,
  },
  checkButton: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  changeButton: {
    marginLeft: 6,
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  seeMoreText: {
    fontSize: 14,
    paddingRight: 4,
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  listItemText: { fontSize: '16px' },
  footer: {
    paddingBottom: 4,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  medStationBanner: {
    marginBottom: 4,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: '60px',
  },
  medStationTexts: {
    flexGrow: 1,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0.5,
    },
  },
  iconLeft: {
    fontSize: '2rem',
    marginLeft: 2,
    marginRight: 2,
  },
  medstationCardTitle: {
    fontSize: '1.2rem',
    fontWeight: 600,
  },
  medstationCardText: {
    fontSize: '1.2rem',
    color: theme.palette.gray.main,
  },
};
